import { HourAndMinute } from '../model/timeoutConfig'

export function convertToMiliSeconds({
	hours,
	minutes,
}: HourAndMinute): number {
	const totalMinutes = hours * 60 + minutes
	const miliSeconds = totalMinutes * 60 * 1000
	return miliSeconds
}
